
import React from "react";
import { Facebook, Twitter, Instagram, Mail, Phone, MapPin } from "lucide-react";

const translations = {
  en: {
    about: {
      title: "About Us",
      text: "The Horn Educational Network is your trusted partner for international education, helping East African and Middle Eastern students achieve their academic dreams."
    },
    contact: {
      title: "Contact Info",
      addresses: [
        "Makka-Almukarama Office Street, Mogadishu, Somalia",
        "112 walters street, Glasgow, UK",
        "KL Traders Square (KLTS) is No. 99, Jalan Gombak, 53000, Kuala Lumpur"
      ],
      phones: [
        { country: "Somalia", number: "+252 770818374" },
        { country: "Malaysia", number: "+60182610860" },
        { country: "UK", number: "+447368303370" }
      ],
      email: "info@thehorneducation.com"
    },
    links: {
      title: "Quick Links",
      items: ["Home", "About Us", "Services", "Study Destinations", "Blog", "Contact"]
    },
    social: {
      title: "Follow Us",
      text: "Stay connected with us on social media"
    },
    copyright: "© 2025 The Horn Educational Network. All rights reserved."
  },
  // ... other translations remain the same
};

function Footer({ language }) {
  const content = translations[language];

  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <img 
              src="https://storage.googleapis.com/hostinger-horizons-assets-prod/2035fa37-35aa-4837-b61a-e7175478d8be/674b8873a7b7a472e81bf1b0f5d0f13c.png" 
              alt="The Horn Educational Network Logo" 
              className="h-16 w-auto mb-4"
            />
            <h3 className="font-bold text-lg mb-4">{content.about.title}</h3>
            <p className="text-white/80">{content.about.text}</p>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">{content.contact.title}</h3>
            <div className="space-y-4 text-white/80">
              {content.contact.addresses.map((address, index) => (
                <p key={index} className="flex items-start gap-2">
                  <MapPin className="w-4 h-4 mt-1 shrink-0" />
                  <span>{address}</span>
                </p>
              ))}
              {content.contact.phones.map((phone, index) => (
                <a 
                  key={index}
                  href={`tel:${phone.number}`} 
                  className="flex items-center gap-2 hover:text-white transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  <span>{phone.country}: {phone.number}</span>
                </a>
              ))}
              <a 
                href={`mailto:${content.contact.email}`} 
                className="flex items-center gap-2 hover:text-white transition-colors"
              >
                <Mail className="w-4 h-4" />
                {content.contact.email}
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">{content.links.title}</h3>
            <ul className="space-y-2">
              {content.links.items.map((item, index) => (
                <li key={index}>
                  <a 
                    href={`#${item.toLowerCase().replace(/\s+/g, '-')}`} 
                    className="text-white/80 hover:text-white transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">{content.social.title}</h3>
            <p className="text-white/80 mb-4">{content.social.text}</p>
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/RabttTlabMqdshwaBaAlswdan/about_contact_and_basic_info" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-accent transition-colors"
              >
                <Facebook className="w-6 h-6" />
              </a>
              <a 
                href="https://www.instagram.com/thehorn_edu/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-accent transition-colors"
              >
                <Instagram className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-center text-white/80">
          <p>{content.copyright}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
